/**
* 系统管理 角色管理
*/
<template>
	<div>
		<!-- 面包屑导航 -->
		<el-breadcrumb separator-class="el-icon-arrow-right">
			<el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item>用户管理</el-breadcrumb-item>
		</el-breadcrumb>
		<!-- 搜索筛选 -->
		<el-form :inline="true" :model="formInline" class="user-search">

			<el-form-item label="搜索：">
				<el-input size="small" v-model="formInline.roleName" placeholder="输入名称"></el-input>
			</el-form-item>
			<el-form-item>
				<el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
				<el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
			</el-form-item>
		</el-form>
		<!--列表-->
		<el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
			element-loading-text="拼命加载中" style="width: 100%;">
			<el-table-column prop="muId" label="id">
			</el-table-column>
			<el-table-column prop="muUsername" label="登录账号">
			</el-table-column>
			<el-table-column prop="muRealName" label="真实姓名">
			</el-table-column>
			<el-table-column prop="roleId" label="角色">
				<template slot-scope="scope">
					<div v-for="item in options" :index="item.id">
						<div v-if="scope.row.roleId ==item.id ">{{item.name}}</div>
					</div>
				</template>
			</el-table-column>
			<el-table-column prop="muCreateDate" label="添加时间">
			</el-table-column>
			<el-table-column align="center" label="操作">
				<template slot-scope="scope">
					<el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
				</template>
			</el-table-column>
		</el-table>
		<!-- 分页组件 -->
		<Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
		<!-- 编辑界面 -->
		<el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog("edit")'>
			<el-form label-width="120px" :model="editForm" ref="editForm">
				<el-form-item v-if="title == '添加'" label="登陆账号" prop="systemNo">
					<el-input size="small" v-model="editForm.userName" auto-complete="off" placeholder="登陆账号">
					</el-input>
				</el-form-item>
				<el-form-item label="真实姓名" prop="roleName">
					<el-input size="small" v-model="editForm.realName" auto-complete="off" placeholder="真实姓名">
					</el-input>
				</el-form-item>
				<el-form-item v-if="title == '添加'" label="密码" prop="roleName">
					<el-input size="small" v-model="editForm.password" auto-complete="off" placeholder="密码">
					</el-input>
				</el-form-item>
				<el-form-item label="角色" prop="roleNo">
					<el-select v-model="editForm.roleId" placeholder="请选择">
						<el-option v-for="item in options" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>

			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click='closeDialog("edit")'>取消</el-button>
				<el-button size="small" type="primary" :loading="loading" v-if="title == '添加'" class="title"
					@click="submitForm('tj')">添加
				</el-button>
				<el-button size="small" type="primary" :loading="loading" v-else class="title"
					@click="submitForm('xg')">保存
				</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import {
		getUserListPage,
		getRoleListPage,
		addSysUser,
		updateUser,
		getCityInfoList
	} from '../../api/userMG'
	import Pagination from '../../components/Pagination'
	export default {
		data() {
			return {
				nshow: true, //switch开启
				fshow: false, //switch关闭
				loading: false, //是显示加载
				editFormVisible: false, //控制编辑页面显示与隐藏
				menuAccessshow: false, //控制数据权限显示与隐藏
				title: '添加',
				editForm: {
					muId: '',
					userName: '',
					realName: '',
					roleId: '',
					password: '',
				},
				options: [],
				formInline: {
					page: 1,
					limit: 20,
					varLable: '',
					varName: '',
					token: localStorage.getItem('logintoken')
				},
				// 删除
				seletedata: {
					ids: '',
					token: localStorage.getItem('logintoken')
				},
				userparm: [], //搜索权限
				listData: [], //用户数据
				// 数据权限
				RoleRight: [],
				RoleRightProps: {
					children: 'children',
					label: 'name'
				},
				// 选中
				checkmenu: [],
				//参数role
				saveroleId: '',
				// 分页参数
				pageparm: {
					currentPage: 1,
					pageSize: 20,
					total: 10
				}
			}
		},
		// 注册组件
		components: {
			Pagination
		},
		/**
		 * 数据发生改变
		 */

		watch: {},

		/**
		 * 创建完毕
		 */

		created() {
			this.getdata(this.formInline)
			this.getRoleListPage()
		},
		methods: {

			// 获取角色列表
			getdata(parameter) {
				this.loading = true
				let pro = {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
					"page": parameter.page,
					"pageSize": parameter.limit,
					"name": parameter.roleName
				}
				getUserListPage(pro)
					.then(res => {
						this.loading = false
						if (res.code == 0) {
							this.listData = res.data.list
							// 分页赋值
							this.pageparm.currentPage = res.data.pageNum
							this.pageparm.pageSize = res.data.pageSize
							this.pageparm.total = res.data.total

						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
			},
			getRoleListPage(parameter) {
				this.loading = true
				let pro = {
					"userId": JSON.parse(localStorage.getItem('userdata')).muId,
					"page": 1,
					"pageSize": 10000,
					"name": ''
				}
				getRoleListPage(pro)
					.then(res => {
						this.loading = false
						if (res.code == 0) {
							this.options = res.data.list
						} else {
							this.$message({
								type: 'info',
								message: res.msg
							})
						}
					})
			},
			// 分页插件事件
			callFather(parm) {
				this.formInline.page = parm.currentPage
				this.formInline.limit = parm.pageSize
				this.getdata(this.formInline)
			},
			// 搜索事件
			search() {
				this.getdata(this.formInline)
			},
			//显示编辑界面
			handleEdit: function(index, row) {
				this.editFormVisible = true
				if (row != undefined && row != 'undefined') {
					this.title = '修改'
					this.editForm.userId = JSON.parse(localStorage.getItem('userdata')).muId,

						this.editForm.muId = row.muId
					this.editForm.userName = row.userName
					this.editForm.realName = row.realName
					this.editForm.roleId = row.roleId
					this.editForm.password = ''
				} else {
					this.title = '添加'
					this.editForm.userId = JSON.parse(localStorage.getItem('userdata')).muId,

						this.editForm.muId = ''
					this.editForm.muUsername = ''
					this.editForm.muRealName = ''
					this.editForm.roleId = ''
					this.editForm.password = ''
				}
			},
			// 编辑、增加页面保存方法
			submitForm(editData) {
				let pro = this.editForm
				if (editData == 'tj') {
					addSysUser(pro)
						.then(res => {
							this.editFormVisible = false
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '角色添加成功！'
								})
								this.getdata(this.formInline)
							} else {
								this.$message({
									type: 'info',
									message: res.baseInfo.msg
								})
							}
						})
				} else {
					updateUser(pro)
						.then(res => {
							this.editFormVisible = false
							if (res.code == 0) {
								this.$message({
									type: 'success',
									message: '账号修改成功！'
								})
								this.getdata(this.formInline)
							} else {
								this.$message({
									type: 'info',
									message: res.baseInfo.msg
								})
							}
						})
				}
			},

			// 关闭编辑、增加弹出框
			closeDialog(dialog) {
				if (dialog == 'edit') {
					this.editFormVisible = false
				} else if (dialog == 'perm') {
					this.menuAccessshow = false
				}
			}
		}
	}
</script>

<style scoped>
	.user-search {
		margin-top: 20px;
	}

	.userRole {
		width: 100%;
	}
</style>



// WEBPACK FOOTER //
// src/views/system/Role.vue